import React from 'react';
import BarChartIcon from '@material-ui/icons/BarChart';
import Search from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import AttachMoney from '@material-ui/icons/AttachMoney';
import FolderOpen from '@material-ui/icons/FileCopy';
import ContactSupport from '@material-ui/icons/ContactSupport';
import SupervisedUserCircle from '@material-ui/icons/SupervisedUserCircle';
import { VER_COMERCIAL, VER_CONTABLE, VER_LISTADO_USUARIOS } from '../../constants/permisos';

export default [
    {
        items: [
            {
                title: 'Inicio',
                href: '/overview',
                icon: HomeIcon,
                permission: -1,
            },
            {
                title: 'Consultas',
                href: '/consultas',
                icon: Search,
                permission: VER_CONTABLE,
                items: [
                    {
                        title: 'Órdenes de Compra',
                        href: '/consultas/ordenes-compra',
                        permission: -1
                    },
                    {
                        title: 'Facturas',
                        href: '/consultas/facturas',
                        permission: -1
                    },
                    {
                        title: 'Pagos',
                        href: '/consultas/pagos',
                        permission: -1
                    },
                    /* Se Oculta Modulos ya que al parecer no cuadra el reponse con lo que se muestra en from
                    {
                        title: 'Notas y Anticipos',
                        href: '/consultas/notas',
                        permission: -1
                    },*/

                    {
                        title: 'Bonificaciones',
                        href: '/consultas/bonificaciones',
                        permission: -1
                    }/*,
                    {
                        title: 'Penalizaciones',
                        href: '/management/customers/1/summary3',
                        permission: -1
                    }*/
                ]
            },
            {
                title: 'Inventarios',
                href: '/inventarios',
                icon: BarChartIcon,
                permission: VER_COMERCIAL,
                items: [
                    {
                        title: 'Consultar Inventarios',
                        href: '/consultas/inventarios/detalle',
                        permission: -1
                    }
                ]
            },
            {
                title: 'Ventas',
                href: '/ventas',
                icon: AttachMoney,
                permission: VER_COMERCIAL,
                items: [
                    {
                        title: 'Consultar ventas',
                        href: '/consultas/ventas-general',
                        permission: -1
                    }
                ]
            },
            {
                title: 'Manuales',
                href: '/manuales',
                icon: FolderOpen,
                permission: VER_COMERCIAL,
                items: [
                    {
                        title: 'Manual de usuario',
                        href: '/manuales/usuarios',
                        permission: -1
                    }
                ]
            },
            {
                title: 'Soporte',
                href: '/soporte',
                icon: ContactSupport,
                permission: VER_COMERCIAL,
                items: [
                    {
                        title: 'Directorio',
                        href: '/soporte/contacto',
                        permission: -1
                    }
                ] 
            }/*,
            {
                title: 'Catálogos',
                href: '/catalogos',
                icon: CategoryIcon,
                permission: VER_COMERCIAL,
                items: [
                    {
                        title: 'Consultar catálogos',
                        href: '/catalogos/detalles',
                        permission: -1
                    }
                ]
            },*/
            /*{
                title: 'Estado de cuenta',
                href: '/management28',
                icon: AccountBalanceWallet,
                permission: -1
            },*/
            /*{
                title: 'Embarques',
                href: '/management2',
                icon: LocalShipping,
                permission: -1,
                items: [
                    {
                        title: 'Confirmación de embarques',
                        href: '/management2/customers22',
                        permission: -1
                    },
                    {
                        title: 'Seguimiento de recepción',
                        href: '/management2/customers112',
                        permission: -1
                    }
                ]
            }*/
        ]
    },
    {
        subheader: 'Usuarios',
        items: [
            {
                title: 'Usuarios',
                href: '/components',
                icon: SupervisedUserCircle,
                permission: VER_LISTADO_USUARIOS,
                items: [
                    {
                        title: 'Listado usuarios',
                        href: '/usuarios/proveedor',
                        permission: VER_LISTADO_USUARIOS,
                    }
                ]
            }
        ]
    }
];
